import { z } from 'zod'

/**
 * Search params schema for f1-settings page
 * This defines the structure of URL search parameters that persist tab state and filters
 */
export const f1SettingsSearchSchema = z.object({
  // Active tab selection
  tab: z.enum(['organization', 'workstation', 'federal-agency', 'nist', 'transactions']).optional(),
  
  // Shared pagination params
  page: z.union([z.string(), z.number()]).optional().transform((val) => {
    const raw = typeof val === 'number' ? val : val && val !== '' ? Number(val) : 1
    return Number.isFinite(raw) && raw > 0 ? raw : 1
  }),
  pageSize: z.coerce.number().optional(),
  sortBy: z.string().optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
  
  // Organization filter params
  orgQuery: z.string().optional(),
  orgSelectedOrganization: z.string().optional(),
  orgSelectedContact: z.string().optional(),
  
  // Workstation filter params
  wsQuery: z.string().optional(),
  wsSelectedStatus: z.string().optional(),
  wsTenantId: z.string().optional(),

  // Federal agency filter params
  faQuery: z.string().optional(),
  faAssignmentScope: z.string().optional(),
  faTenantId: z.string().optional(),
})

export type F1SettingsSearchParams = z.infer<typeof f1SettingsSearchSchema>

